/*
 * @Author: 张天昊
 * @Date: 2024-05-23 11:04:50
 * @LastEditTime: 2025-03-20 17:51:33
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @Description:
 * @FilePath: /Gov-Web/Mobile/src/service/modules/itineraryUniversal.js
 */
import { stringify } from 'qs';
import Cookies from 'js-cookie';
import $http from '../../utils/http';
import { SCENE_TYPE } from '../../pages/itineraryUniversal/constants';

let currentDetailPrefix = '';
let currentDetailBaseURL = '';

/**
 * 无需角色权限的行程单详情接口
 * @param {*} data
 * @param {string} data.id 行程单id
 * @returns
 */
export const getItineraryDetailInfo = (data) => {
  const params = {
    teamId: data.id
  };
  if (process.env.VUE_APP_ENV === 'dev') {
    params.type = 'openscenic';
  }
  return $http({
    url: (currentDetailPrefix = '/pass/this/itinerary') + '/details',
    params,
    method: 'GET',
    baseURL:
      (currentDetailBaseURL = `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api/itinerary`)
  });
};

/**
 * 需要场景值动态判断请求路径，带角色权限的行程单详情接口
 * @param {*} data
 * @param {string} data.id 行程单id
 * @param {string} scene 场景值 team-supervision ｜ travel-agency ｜ guide
 * @returns
 */
export const getItineraryDetailInfoByScene = (data, scene = '') => {
  const url = {
    [SCENE_TYPE.团队监管]: '/team-supervision/api/itinerary/itinerary',
    [SCENE_TYPE.旅行社]: '/itinerary/itinerary',
    [SCENE_TYPE.导游]: '/guide_backend/api/itinerary/itinerary'
  };
  const currentUrl = url[scene];
  if (!currentUrl) {
    return Promise.reject(new Error('invalid scene'));
  }
  return $http({
    url: (currentDetailPrefix = currentUrl) + '/details',
    params: {
      id: data.id
    },
    method: 'GET',
    baseURL:
      (currentDetailBaseURL = `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api`)
  });
};

/**
 * 查看用户隐私信息
 * **/

export const httpCheckUserPrivate = (id) => {
  return $http({
    url: '/touristPrivacy/viewTouristPrivacy',
    method: 'GET',
    params: { id },
    baseURL: `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api/team-supervision/api/itinerary`
  });
};

/**
 * 导游拒绝带团确认带团
 */
export const guideTeamConfirm = (data) => {
  return $http({
    url: '/guide/teamConfirm',
    method: 'GET',
    params: data,
    baseURL: `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api/guide_backend/itinerary_backend`
  });
};

/**
 * 请求行程单pdf
 * @param {*} data
 * @param {*} data.id 行程单id
 * @returns 二进制pdf文件
 */
export const getItineraryDetailPdf = (data) => {
  console.log(currentDetailPrefix, currentDetailBaseURL);
  if (!currentDetailPrefix) {
    return;
  }
  let params = {};
  if (currentDetailPrefix.includes('pass')) {
    params.teamId = data.id;
    if (process.env.VUE_APP_ENV === 'dev') {
      params.type = 'openscenic';
    }
  } else {
    params.id = data.id;
  }
  return $http({
    url: currentDetailPrefix + '/exportDetails',
    method: 'GET',
    params,
    responseType: 'blob',
    headers: {
      Accept: 'application/pdf'
    },
    baseURL: currentDetailBaseURL
  });
};

export const createGetItineraryDetailPdfUrl = (data) => {
  if (!currentDetailPrefix) {
    return;
  }
  let params = {
    'X-Token': Cookies.get('X-Token')
  };
  if (currentDetailPrefix.includes('pass')) {
    params.teamId = data.id;
    if (process.env.VUE_APP_ENV === 'dev') {
      params.type = 'openscenic';
    }
  } else {
    params.id = data.id;
  }

  return (
    currentDetailBaseURL +
    currentDetailPrefix +
    '/exportDetails?' +
    stringify(params)
  );
};

/**
 * 旅行社-行程单-通过审核
 */
export const agencyAuditConfirm = (data) => {
  return $http({
    url: '/itinerary/auditYesItineraryInfo',
    method: 'GET',
    params: data,
    baseURL:
      (currentDetailBaseURL = `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api/itinerary`)
  });
};


/**
 * 旅行社-行程单-其他变更
 */
export const agencySaveOtherChangeDraft = (data) => {
  return $http({
    url: '/itinerary/change/saveOtherChangeDraft/false',
    method: 'POST',
    isPayload:true,
    data,
    baseURL:
      (currentDetailBaseURL = `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api/itinerary`)
  });
 
};

// -行程单上报-
export function reportTeamChange(params) {
  return $http({
    url: '/itinerary/change/reportTeamChange',
    baseURL:
      (currentDetailBaseURL = `${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api/itinerary`),
    method: "get",
    params: params
  });
};

// 根据游客 ID 获取游客保险详情
export function getInsuranceDetailByUserId(params, scene = '') {
  const url = {
    [SCENE_TYPE.团队监管]: '/team-supervision/api',
    [SCENE_TYPE.旅行社]: '',
    [SCENE_TYPE.导游]: '/guide_backend/api'
  };
   // t-tio.ybsjyyn.com/team-supervision-backend/api /team-supervision/api /open-insurance/insurance/insuranceDetail
  // t-tio.ybsjyyn.com/team-supervision-backend/api /open-insurance/insurance/insuranceDetail
  // t-tio.ybsjyyn.com/team-supervision-backend/api /guide_backend/api /open-insurance/insurance/insuranceDetail
  const currentUrl = url[scene] || '';
  return $http({
    url: `${currentUrl}/open-insurance/insurance/insuranceDetail`,
    baseURL:`${process.env.VUE_APP_BASE_URL}/team-supervision-backend/api`,
    method: 'get',
    params: params
  })
}

